import { useEffect } from "react";

const useEnterNavigation = (formRef, options = {}) => {
  const {
    autoFocusFirst = true
  } = options;

  useEffect(() => {
    const form = formRef?.current;
    if (!form) return;

    const getFocusableElements = () =>
      Array.from(form.elements).filter(
        (el) =>
          ["INPUT", "SELECT", "TEXTAREA"].includes(el.tagName) &&
          !el.disabled &&
          el.type !== "hidden"
      );

    // ✅ Auto focus first field only
    if (autoFocusFirst) {
      const elements = getFocusableElements();
      if (elements.length > 0) {
        elements[0].focus();
      }
    }

  }, [formRef, autoFocusFirst]);
};

export default useEnterNavigation;